import React from 'react';
import { BarChart, Bar, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, Cell } from 'recharts'; 
import CustomTooltip from './CustomTooltip'; // Adjust the path as needed

const ProfitChart = ({ data }) => {debugger;
    // Calculate min and max values c
     const minProfit = Math.min(...data.map(d => d['PROFIT/LOSS']));
     const maxProfit = Math.max(...data.map(d => d['PROFIT/LOSS'])); // Generate custom ticks 
     const generateTicks = (min, max, interval) => { 
        const ticks = []; const start = Math.floor(min / interval) * interval; 
        const end = Math.ceil(max / interval) * interval; 
        for (let i = start; i <= end; i += interval) { ticks.push(i); } console.log('min '+min+ ' max '+max);
        return ticks;
     };

     const generateXTicks = (length) => { 
        const ticks = []; const start = 5; 
        const end = length; 
        if(length == 0) return [5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75, 80, 85, 90, 95, 100];
        else {
            for (let i = start; i <= end; i += 5) 
                { ticks.push(i); } 
            //if(end/start == 0)
               return ticks;
            //else { ticks.push( (Math.floor(end/start) + 1) * start ); return ticks; }
        }
     };

    const determineInterval = (range) => { 
        if (range <= 10000) { return 500; } else if (range <= 15000) { return 1000; } else { return 2000; }
   };

   const range = maxProfit - minProfit; const interval = determineInterval(range);

    const customTicks = generateTicks(minProfit, maxProfit, interval);
    const customXTicks = generateXTicks(data.length);// [5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75, 80, 85, 90, 95, 100];

    return (
        <ResponsiveContainer width="100%" height={350}>
            <BarChart data={data}
                margin={{ top: 5, right: 10, left: 10, bottom: 5 }}>
                <CartesianGrid strokeDasharray="3 3" vertical={true} horizontal={true} />
                <XAxis ticks={customXTicks}  dataKey="row_num" interval={0} />
                <YAxis ticks={customTicks} label={{ value: 'PROFIT/LOSS', angle: -90, position: 'insideLeft'}} domain={['auto', 'auto']} scale="linear"/>
                <Tooltip content={<CustomTooltip />}/>
                <Legend />
                <Bar dataKey="PROFIT/LOSS">
                {data.map((entry, index) => ( <Cell key={`cell-${index}`} fill={entry["PROFIT/LOSS"] >= 0 ? 'green' : 'red'} /> ))} 
                </Bar>
            </BarChart>
        </ResponsiveContainer>
    );
};

export default ProfitChart;
